import * as d3 from "d3";

interface SvgDimensions {
  width: number;
  height: number;
  marginLeft: number;
  marginRight: number;
  marginTop: number;
  marginBottom: number;
}

export function createOrUpdateSVG(
  plotClassName: string,
  {
    width,
    height,
    marginLeft,
    marginRight,
    marginTop,
    marginBottom,
  }: SvgDimensions,
  clear: boolean,
) {
  const totalWidth = width + marginLeft + marginRight;
  const totalHeight = height + marginTop + marginBottom;

  const svg = d3.select(`svg.${plotClassName}`);

  if (svg.empty()) {
    // TODO: Check with Pedro if this is needed.
    // This was creating ghost plots by appending SVGs to body
    // instead of using the existing SVG element that React already renders
    // const newSvg = d3
    //   .select("body")
    //   .append("svg")
    //   .attr("class", plotClassName)
    //   .attr("viewBox", [0, 0, totalWidth, totalHeight])
    //   .attr("style", "max-width: 100%; height: auto;");

    // newSvg
    //   .append("rect")
    //   .attr("class", "bg-rect")
    //   .attr("x", 0)
    //   .attr("y", 0)
    //   .attr("width", totalWidth)
    //   .attr("height", totalHeight)
    //   .attr("fill", "white");

    // Instead of creating a new SVG in the body, log an error and return
    console.error(
      `SVG with class ${plotClassName} not found. Plot cannot be created.`,
    );
    return null;
  }
  svg.attr("viewBox", [0, 0, totalWidth, totalHeight]);

  if (clear) {
    svg.selectAll("*").remove();
  }

  let bg = svg.select("rect.bg-rect");
  if (bg.empty()) {
    bg = svg
      .insert("rect", ":first-child")
      .attr("class", "bg-rect")
      .attr("x", 0)
      .attr("y", 0) as unknown as d3.Selection<
      d3.BaseType,
      unknown,
      HTMLElement,
      unknown
    >;
  }
  bg.attr("width", totalWidth)
    .attr("height", totalHeight)
    .attr("fill", "white");

  return svg;
}
